import { render, staticRenderFns } from "./PdfDownloadReportLogTable.vue?vue&type=template&id=63876648&scoped=true"
import script from "./PdfDownloadReportLogTable.vue?vue&type=script&lang=js"
export * from "./PdfDownloadReportLogTable.vue?vue&type=script&lang=js"
import style0 from "./PdfDownloadReportLogTable.vue?vue&type=style&index=0&id=63876648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63876648",
  null
  
)

export default component.exports